module.exports = "/img/_/_/_/assets/images/creeper/book/common//7.jpg?a87cd3727a78bbbde95e13d3a803f3cd";